var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.windowWidth > 480)?_c('div',{staticClass:"feedback-container",on:{"click":_vm.handleFeedback}},[_c('img',{staticStyle:{"cursor":"pointer","filter":"drop-shadow(2px 0px 2px #3d3737)"},attrs:{"width":"24px","src":require('@/assets/images/mailbox.svg')}}),_c('strong',[_vm._v(" "+_vm._s(_vm.$t('zimbraNokey.feedback_mailbox'))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }